import { handleActions } from 'redux-actions';
import types from './types';
import { mergeIn } from '../../../../helpers/stateHelpers';

const errorRequestReducer = handleActions({
  [types.SET_REQUEST_ERROR]: mergeIn(action => action.payload),
}, null);

export default errorRequestReducer;
